import React from 'react'
import { h } from '@app/helpers/translationHelper'

const History = (props) => {
  return(
    <section className="history" id="about">
      <div className="history__wrapper">
        <h1 className="bold history__title">
          { I18n.t('landing.history.heading') }
        </h1>
        <div className="history__image">
          <p className="history__caption">
            { I18n.t('landing.history.timeline_1') }
          </p>
          <p className="history__caption"
             dangerouslySetInnerHTML={ h('landing.history.timeline_2') } />
          <p className="history__caption"
             dangerouslySetInnerHTML={ h('landing.history.timeline_3') } />
        </div>

        <div className="history__timeline">
          <div className="history__timeline-row">
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.first_year_html') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.second_year_html') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.third_year_html') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.fourth_year_html') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.fifth_year_html') }
            />
          </div>
          <div className="history__timeline-row">
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.first_year_amount') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.second_year_amount') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.third_year_amount') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.fourth_year_amount') }
            />
            <div className="history__timeline-col"
                 dangerouslySetInnerHTML={ h('landing.history.fifth_year_amount') }
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default History
